var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 189,
    viewBox: "0 0 316 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.496 144C123.496 144 115.996 140.5 111.996 138C107.997 135.5 100.996 129 100.996 129C100.996 129 75.9961 165.5 75.0438 167C74.0915 168.5 71.6438 172.1 72.0438 176.5C72.4438 180.9 75.0433 183.667 76.0433 184.5C77.8767 186.333 82.0433 189 86.5433 188.5C92.0993 187.883 95.0902 184.5 97.0433 182.5C98.9964 180.5 114.996 156.5 123.496 144Z",
    fill: "#E3E0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 123C113.922 117.615 109.167 111.667 106.5 108C104.5 110.5 100.388 116.131 99.5002 118.5C98.0003 122.5 98.6544 126.361 100.001 129.5C101.034 131.909 108.218 136.812 111.5 139C114.5 141 121.1 144.6 123.5 145C126.5 145.5 130.5 145 134 143C138.005 140.712 140.512 135.732 143 132C139.5 130.5 132.5 130 122 123Z",
    fill: "#D0CBF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 6.05141C159.23 6.16104 157.256 6.27066 154.954 6.30721C140.519 6.48993 124.513 13.6525 113.33 24.9081C100.905 37.4061 94.291 53.4855 94.291 70.99C94.3276 84.292 97.9454 96.315 105.181 107.169C114.756 121.494 129.264 131.251 146.366 134.905C151.08 135.929 162.044 136.294 167.269 135.636C177.794 134.357 188.428 130.191 197.126 123.979C216.019 110.494 226.507 87.2521 223.986 64.4487C223.109 56.409 221.208 49.9407 217.481 42.2665C212.401 31.888 205.202 23.7021 195.408 17.1242C186.601 11.2041 175.382 7.14772 165.734 6.45338C164.127 6.34375 162.044 6.16104 161.13 6.08795C160.216 5.97832 159.412 5.97832 159.303 6.05141ZM169.097 23.7752C178.05 25.6024 185.907 29.7684 192.594 36.1271C199.574 42.7415 203.886 50.16 206.335 59.8076C207.322 63.5351 207.395 64.339 207.395 70.9535C207.395 78.5546 207.066 80.7838 205.129 86.6674C201.365 97.9229 192.558 108.301 182.07 113.82C162.994 123.796 140.336 120.361 125.171 105.122C118.556 98.5077 114.281 90.7603 112.161 81.5512C111.065 76.9102 110.845 68.4685 111.613 63.6082C113.294 53.4124 117.862 44.4591 125.171 37.1138C132.735 29.4761 142.712 24.5427 153.31 23.1174C157.183 22.5693 164.821 22.8982 169.097 23.7752Z",
    fill: "#E3E0FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.097 23.7752C178.05 25.6024 185.907 29.7684 192.594 36.1271C199.574 42.7415 203.886 50.16 206.335 59.8076C207.322 63.5351 207.395 64.339 207.395 70.9535C207.395 78.5546 207.066 80.7838 205.129 86.6674C201.365 97.9229 192.558 108.301 182.07 113.82C162.994 123.796 140.336 120.361 125.171 105.122C118.556 98.5077 114.281 90.7603 112.161 81.5512C111.065 76.9102 110.845 68.4685 111.613 63.6082C113.294 53.4124 117.862 44.4591 125.171 37.1138C132.735 29.4761 142.712 24.5427 153.31 23.1174C157.183 22.5693 164.821 22.8982 169.097 23.7752Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.486 60.9406C126.048 61.4888 125.719 62.1831 125.719 62.5486C125.719 63.7911 127.4 65.6183 129.739 66.8973C131.858 68.0667 132.406 68.2129 134.855 68.2129C138.107 68.2129 140.483 67.2993 142.639 65.1797C146.001 61.8908 142.748 58.1633 139.057 61.0868C136.28 63.2795 133.795 63.2795 130.981 61.0503C129.227 59.6616 127.546 59.6251 126.486 60.9406Z",
    fill: "#E3E0FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.492 60.5752C174.14 61.5253 174.396 63.5718 176.077 65.1797C178.123 67.2262 180.608 68.1763 183.641 68.2129C186.419 68.2129 187.88 67.7378 190.292 66.1299C192.119 64.9239 193.106 63.2429 192.741 62.0735C192.046 59.7347 189.89 59.3327 187.698 61.0503C184.884 63.2795 182.399 63.2795 179.621 61.0868C178.086 59.8809 176.734 59.6981 175.492 60.5752Z",
    fill: "#E3E0FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.196 67.6273C152.834 68.5044 147.901 72.1953 146.914 74.6438C146.293 76.1055 146.987 77.7134 148.412 78.2251C149.874 78.7367 150.861 78.2981 152.322 76.471C152.98 75.667 154.296 74.5341 155.246 73.986C158.827 71.8664 163.505 72.9262 166.355 76.471C167.817 78.2981 168.804 78.7367 170.266 78.2251C171.691 77.7134 172.385 76.1055 171.764 74.6438C171.07 72.9627 167.269 69.5641 164.93 68.5409C162.664 67.5177 158.316 67.0791 156.196 67.6273Z",
    fill: "#E3E0FB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8115,
    cy: 43.8229,
    rx: 5.81154,
    ry: 5.82291,
    fill: "#E3E0FB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.81154,
    cy: 56.8229,
    rx: 5.81154,
    ry: 5.82291,
    fill: "#E3E0FB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8096,
    cy: 5.82291,
    rx: 5.81154,
    ry: 5.82291,
    fill: "#E3E0FB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.8115,
    cy: 81.8229,
    rx: 5.81154,
    ry: 5.82291,
    fill: "#E3E0FB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.8096,
    cy: 12.8229,
    rx: 5.81154,
    ry: 5.82291,
    fill: "#E3E0FB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.92,
    cy: 102.449,
    rx: 5.81154,
    ry: 5.82291,
    transform: "rotate(-164.088 269.92 102.449)",
    fill: "#E3E0FB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.617,
    cy: 100.205,
    rx: 5.81154,
    ry: 5.82291,
    transform: "rotate(-164.088 308.617 100.205)",
    fill: "#E3E0FB"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.002,
    cy: 143.485,
    rx: 5.81154,
    ry: 5.82291,
    transform: "rotate(-164.088 293.002 143.485)",
    fill: "#E3E0FB"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.127,
    cy: 60.1936,
    rx: 5.81154,
    ry: 5.82291,
    transform: "rotate(-164.088 262.127 60.1936)",
    fill: "#E3E0FB"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.185,
    cy: 127.858,
    rx: 5.81154,
    ry: 5.82291,
    transform: "rotate(-164.088 235.185 127.858)",
    fill: "#E3E0FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.892b885276d6b5c540b3b05c1b893b06.svg";
export { ForwardRef as ReactComponent };